import { TInsuredNew, TChildCount, IFinalSelection } from 'Constants/groupTypes'
import {
  MemberSelectionInitials,
  childCountInitials,
  FinalSelectionInitials,
} from '../BobSellJourney/initials'
import { createSlice } from '@reduxjs/toolkit'
import { INomineeDetails, IProposerDetailsLife } from 'types'

export interface IStateGroupLife {
  lead: {
    memberSelection: TInsuredNew[]
    childCount: TChildCount
    finalSelection: IFinalSelection[]
  }
  suitabilityFormDetails: IProposerDetailsLife
  quotationDetails: {
    [key: string]: any
  }
  nomineeDetails: INomineeDetails
}
export const initialState: IStateGroupLife = {
  lead: {
    memberSelection: MemberSelectionInitials,
    childCount: childCountInitials,
    finalSelection: FinalSelectionInitials,
  },
  suitabilityFormDetails: {
    occupation: '',
    address1: '',
    address2: '',
    pincode: '',
    city: '',
    state: '',
    phone: '',
    email: '',
    annualIncome: '',
  },
  quotationDetails: {},
  nomineeDetails: {
    nomineeSalutation: '',
    nomineeFirstName: '',
    nomineeLastName: '',
    dob: '',
    nomineeGender: '',
    relationship: '',
    nomineeEmail: '',
    nomineePhoneNumber: '',
  },
}

const groupLifeSlice = createSlice({
  name: 'groupLifeSlice',
  initialState: initialState,
  reducers: {
    updateLeadDetails: (state, action) => {
      state.lead = action.payload
    },
    updateSuitabilityFormDetails: (state, action) => {
      state.suitabilityFormDetails = action.payload
    },
    updateQuotationDetails: (state, action) => {
      state.quotationDetails = action.payload
    },
    updateNomineeDetails: (state, action) => {
      state.nomineeDetails = action.payload
    },
    resetGroupLifeData: () => initialState,
  },
})

const { reducer } = groupLifeSlice
const {
  updateLeadDetails,
  updateSuitabilityFormDetails,
  updateQuotationDetails,
  resetGroupLifeData,
  updateNomineeDetails,
} = groupLifeSlice.actions

export {
  reducer as groupLifeReducer,
  updateLeadDetails,
  updateQuotationDetails,
  resetGroupLifeData,
  updateNomineeDetails,
  updateSuitabilityFormDetails,
}
